/**
 * Change-owner dialog in Team → Managers (PROD-637). Client-side only; stable keys,
 * never names or emails.
 *
 *   owner_change_opened    { restaurant_id }
 *   owner_change_confirmed { restaurant_id, new_owner: existing | new | none, previous_owner: keep_as_operator | remove | null }
 *   owner_change_failed    { restaurant_id, error_code }
 */
export const OwnerChangeEvent = Object.freeze({
  Opened: 'owner_change_opened',
  Confirmed: 'owner_change_confirmed',
  Failed: 'owner_change_failed',
});
